import moment from "moment";

function MLEDraftData(data) {
    this.tableData = this.createMleFieldsFields(data);
}

MLEDraftData.prototype = Object.assign(MLEDraftData.prototype, {
    createMleFieldsFields(draftDetails) {
        console.log("draft details", draftDetails);
        return (
            draftDetails &&
            draftDetails.map(row => this.createRow(row))
        );
    },
    createRow(row) {
        const {
            id,
            uniqueIdentifier,
            sections,
            createdOn,
            intentId,
            updatedBy
        } = row;
        let date = moment(createdOn).format('DD/MM/YYYY HH:mm:ss');
        // console.log("date...", date, sections?.[0]?.data);
        // fetch entity name
        const entityName = sections?.[0]?.data?.legalName;
        // fetch email id
        const emailId = sections?.[0]?.data?.emails?.toString();
        // fetch maker id
        const makerId = updatedBy;
        return {
            id,
            uniqueIdentifier,
            sections,
            createdOn: date,
            intentId,
            entityName,
            emailId,
            makerId
        };
    },
});

export default MLEDraftData;
